import React from 'react';

export const FileTabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      style={{flex: 1, overflowY: "auto"}}
      role="tabpanel"
      hidden={value !== index}
      
    >
      {children}
    </div>
  );
}